import { HttpHeaders } from '@angular/common/http';

export const CONFIG = {
  IDAPP: 3,
  MODO_CONEXION: 'P',
  ESTADO_ACTIVO: 'A',
  ID_TIPO_PREGUNTA: 1,
  RESPUESTA_PREGUNTA: 'hagroyelectronic',
};

export enum Action {
  None,
  New,
  Update
}

export const HTTPOPTIONS = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

export const ALERTCLASS = {
  DEFAULT: 'alert-default',
  PRIMARY: 'alert-primary',
  SUCCESS: 'alert-success',
  INFO: 'alert-info',
  WARNING: 'alert-warning',
  DANGER: 'alert-danger'
};


export const ESTADOS = {
  INICIADO: 'I',
  CONECTADO: 'C',
  ERROR: 'X',
  TERMINADO: 'T'
}


export const RESPONSE_AUTH = {
  OK: 'wOK',
  ERROR: 'wEX'
}

export const PLAN = {
  ALCOM_BASIC: 1,
  ALCOM_PLUS: 2,
  ALCOM_ACTIVE: 3,
  ALCOM_VISUAL_ACTIVE: 4,
  ALCOM_MONITOREO: 5
}

export const PLAN_MONITOREO = {
  COMUNIDAD: 1,
  BASICO: 2,
  EMPRESARIAL: 3,
  EMPRESARIAL_PLUS: 4,
  CORPORATIVO: 5
}
